import { Injectable } from '@angular/core';
import { blockUi } from '@bndes/bndes-ux4/bndes-angular-utils';
import { Observable, catchError } from 'rxjs';
import { JanelaSolicitacaoHonra, JanelaSolicitacaoHonraEnvio, JanelaSolicitacaoHonraResposta } from 'src/app/model/janela-solicitacao-honra.model';
import { JanelaEnvioProtocolo } from 'src/app/model/protocolo-arquivo.model';
import { RetornoMensagemSimplesDTO } from 'src/app/model/questionario.model';
import { ResultadoPaginado } from 'src/app/model/resultado';
import { FgiBackEndService } from 'src/app/shared/fgi-back-end.service';

@Injectable({
  providedIn: 'root'
})
export class JanelaSolicitacaoHonraService extends FgiBackEndService<JanelaSolicitacaoHonra> {

  getNewEntity(): JanelaSolicitacaoHonra {
    return new JanelaSolicitacaoHonra();
  }

  protected getResourceURL(): string {
    return 'front/solicitacoes-honra';
  }

  getJanelas(params: JanelaSolicitacaoHonraEnvio): Observable<ResultadoPaginado<JanelaSolicitacaoHonraResposta>> {
    const options = blockUi({ params });
    
    return this.http.get(`${this.BASE_URL}/janelas`, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<ResultadoPaginado<JanelaSolicitacaoHonraResposta>>;
  }

  estenderPeriodo(idJanela: number, novaDataFechamento: string): Observable<RetornoMensagemSimplesDTO> {
    const options = blockUi();

    return this.http.post(`${this.BASE_URL}/janelas/${idJanela}/estender-periodo/${novaDataFechamento}`, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<RetornoMensagemSimplesDTO>;
  }

  getJanelaEnvioDoMesAtual(): Observable<JanelaEnvioProtocolo> {
    return this.http.get(`${this.BASE_URL}/janela-envio-atual`).pipe(
      catchError((e) => this.handleError(e))) as Observable<JanelaEnvioProtocolo>;
  }
}
